import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberrace'
})
export class NumberracePipe implements PipeTransform {

  transform(value: any, args: any): any {
      if (!value || !args) {
          return null;
      }

     let arrayDescRace = '';
     arrayDescRace = value.split('#');
     if ( args === 'desc' ) {
        return arrayDescRace[0];
     }
     if ( args === 'num' ) {
        return arrayDescRace[1].replace(' ', '' );
     }
  }

}
